module.exports = __webpack_public_path__ + "files/flyer_gds.pdf";